import Stack from "ui/Stack"
import { PX14 } from "theme/sizes"
import styled from "@emotion/styled"
import ImageBase from "app/files/components/Image"
import NextImageBase from "next/image"
import TextBase from "ui/Text"
import Group from "ui/Group"
import router from "next/router"
import { MutableRefObject } from "react"
import { DisplayStateType } from "app/radio/types"
import { useAtomValue } from "jotai"
import {
  currentPlayingItemAtom,
  playingStateAtom,
  playlistInfoAtom,
} from "app/radio/state"
import { DARK_BLUE_COLOR } from "theme/colors"
import { css } from "@emotion/react"
import {
  parseAsBoolean,
  parseAsInteger,
  parseAsNumberLiteral,
  useQueryState,
} from "nuqs"
import { MODAL_QUERY_KEY } from "app/playlists/consts"

const Root = styled(Group)`
  height: inherit;
  width: 100%;
  position: relative;
`

const GradientOverlay = styled.div<{ theme?: "light" | "dark" }>`
  position: absolute;
  height: inherit;
  width: 100%;
  pointer-events: none;
  background: rgb(0, 0, 0);
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 85%,
    ${(p) => (p.theme === "light" ? "white" : DARK_BLUE_COLOR)} 100%
  );

  content: "";
  display: block;
  top: 0;
  left: 0;
`

const Image = styled(ImageBase)`
  border-radius: 4px;
  flex-shrink: 0;
  cursor: pointer;
`

const NextImage = styled(NextImageBase)`
  border-radius: 4px;
`

const TextContainer = styled(Stack)<{
  displayState?: (typeof DisplayStateType)[keyof typeof DisplayStateType]
  libraryOpen?: boolean
}>`
  overflow: hidden;
  ${(p) =>
    !(p.displayState === DisplayStateType["LARGE"] || p.libraryOpen) &&
    css`
      max-width: 164px;
    `}
`

const Text = styled(TextBase)`
  /*color: white;*/
  white-space: nowrap;
`

const TextLink = styled(Text)`
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

const NowPlayingInfo = ({
  theme,
  libraryOpen,
}: {
  theme?: "light" | "dark"
  libraryOpen?: boolean
}) => {
  const playingState = useAtomValue(playingStateAtom)
  const currentPlayingItem = useAtomValue(currentPlayingItemAtom)
  const displayState =
    playingState.type === "VISIBLE" ? playingState.displayState : undefined
  const playlistInfo = useAtomValue(playlistInfoAtom)
  const [open, setOpen] = useQueryState(MODAL_QUERY_KEY, parseAsInteger)
  return (
    <Root gap="16px" align="center">
      {currentPlayingItem && currentPlayingItem.lesson?.listImage ? (
        <Image
          file={currentPlayingItem.lesson.listImage}
          width={58}
          height={58}
          alt=""
          onClick={async () => {
            if (!currentPlayingItem.lesson) return
            await router.push(`/les/${currentPlayingItem.lesson.slug}`)
          }}
        />
      ) : (
        <NextImage
          src="/images/logo-square-placeholder.svg"
          width={58}
          height={58}
          alt=""
        />
      )}
      {currentPlayingItem && currentPlayingItem.lesson ? (
        <>
          {/*{(containerRef.current && containerRef.current.offsetWidth > 769) ||
          displayState === "small" ? (*/}
          <TextContainer
            align="flex-start"
            displayState={displayState}
            libraryOpen={libraryOpen}
          >
            <TextLink
              size={PX14}
              bold
              onClick={async () => {
                if (playlistInfo?.route)
                  return await router.push(playlistInfo.route.href)
                if (playlistInfo?.libraryPlaylistId)
                  return setOpen(playlistInfo.libraryPlaylistId)
              }}
            >
              {playlistInfo?.listName}
            </TextLink>
            <TextLink
              size={PX14}
              onClick={async () => {
                if (!currentPlayingItem || !currentPlayingItem.lesson) return
                await router.push(`/les/${currentPlayingItem.lesson.slug}`)
              }}
            >
              {currentPlayingItem.lesson.displayTitle}
            </TextLink>
          </TextContainer>
          {/*) : null}*/}
        </>
      ) : null}
      <GradientOverlay theme={theme} />
    </Root>
  )
}

export default NowPlayingInfo
